import { CSSProperties } from 'react';
import { COLORS, GLASS, META } from '../../../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '1.25rem',
    marginTop: '3rem',
  },
  card: {
    ...GLASS,
    border: `1px dashed ${COLORS.borderStrong}`,
    padding: '1.75rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.25rem',
  },
  quote: {
    fontSize: '1.0625rem',
    lineHeight: 1.65,
    color: COLORS.text,
  },
  handle: {
    ...META,
    fontSize: '0.66rem',
    color: COLORS.accent,
  },
  games: {
    ...META,
    display: 'block',
    fontSize: '0.62rem',
    color: COLORS.label,
    marginTop: '0.35rem',
  },
};
